<awair-index-dot style="margin-right: 8px;"
                 [color]="sensorColor"
                 [width]="8"
                 [height]="8">
</awair-index-dot>
<p class="__sensor-key">{{componentType | sensorHeader}} ({{componentType | sensorUnit: temperatureUnit}})</p>
<p class="__spacer"></p>
<p class="__sensor-value">{{value == null ? '-' : value | number: '1.0-0'}}</p>
